import { useFilteredByModulePaths } from '@/src/hooks/location-module/location-module.hooks'
import { NOTIFICATION_TABS, type NotificationTab } from './NotificationInbox.consts'

export const useNotificationTabs = (): NotificationTab[] => useFilteredByModulePaths(NOTIFICATION_TABS)
